import React from "react";
import {Telegram} from "@mui/icons-material";
import {Accordion, AccordionDetails, AccordionSummary} from "@mui/joy";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DoneSharpIcon from "@mui/icons-material/DoneSharp";


const OurServices = () => {

    const onGroupClick = () => {
        window.open('https://t.me/buyer_china_to_russia')
    }

    const onDocumentPersonClick = () => {
        window.open('https://t.me/+dvsEQMJfEVplYTgy')
    }


    return (
        <div>
            <div className={'blocks-wrapper'} style={{paddingBottom: 0}}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <div className={'other-services'}>
                            Մեր ծառայությունները
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <ul className={'features'}>
                            <li className="list-item" onClick={onGroupClick}>
                                <DoneSharpIcon sx={{ color: '#9f0f91'}}/><p className={'li-item'}>Buyer, Cargo` Ռազմիկ, Էդվին
                                </p> <Telegram
                                              sx={{color: "#1877F2"}}/>
                            </li>
                            <br/>
                            <li className="list-item">
                                <DoneSharpIcon sx={{ color: '#9f0f91'}}/><p className={'li-item'}>Անձնական մենեջեր՝ Մարիամ</p>
                            </li>
                            <br/>
                            <li className="list-item">
                                <DoneSharpIcon sx={{ color: '#9f0f91'}}/><p className={'li-item'}>Ինֆոգրաֆիկայի մասնագետ՝ Աննա, Տելեգրամ - @AnnadesignWB</p>
                            </li>
                            <br/>
                            <li className="list-item" onClick={onDocumentPersonClick}>
                                <DoneSharpIcon sx={{ color: '#9f0f91'}}/><p className={'li-item'}>Փաստաթղթերի մասնագետ՝ Օֆելյա</p><Telegram
                                 sx={{color: "#1877F2"}}/>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <br/>
            </div>
            <div className={'blocks-wrapper'}>
                <h4>
                    Սովորիր 1 ամիս, ձեռք բեր բազմաշերտ նոր մասնագիտություն, որը քեզ հնարավորություն կտա ստեղծել զարգացող
                    կարիերա և անսահմանափակ եկամուտների աճ։
                    Եվ ինչպես ասում են с деньгами купите большие деньги ու եթե ստացվել է մեկի մոտ, կստացվի նաև քեզ մոտ:
                </h4>
            </div>
        </div>
    );
};

export default OurServices;
